import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import UserService from "../../services/UserService";

const PublicRoute = ({ isAuthenticated, component: Component, ...rest }) => {
	if (isAuthenticated)
		return <Route {...rest} render={(props) => (<Redirect to="/dashboard" />)} />;

	return <Route {...rest} render={(props) => (<Component {...props} />)} />;
};

PublicRoute.propTypes = {
	component: PropTypes.func.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
	return {
		isAuthenticated: !!(state.userLoginData && state.userLoginData.token)
	};
}

export default connect(mapStateToProps)(PublicRoute);


// WEBPACK FOOTER //
// ./src/components/routes/PublicRoute.js